import { render, staticRenderFns } from "./DeleteMenuElement.vue?vue&type=template&id=6fb3251b&"
import script from "./DeleteMenuElement.vue?vue&type=script&lang=js&"
export * from "./DeleteMenuElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports